import { parseISO } from '../date'

const publicHolidaysGermany: string[] = [
  // 2024
  '2024-01-01', // New Year's Day
  '2024-03-29', // Good Friday
  '2024-04-01', // Easter Monday
  '2024-05-01', // Labour Day
  '2024-05-09', // Ascension Day
  '2024-05-20', // Whit Monday
  '2024-10-03', // Day of German Unity
  '2024-10-31', // Reformation Day
  '2024-12-25', // Christmas Day
  '2024-12-26', // St. Stephen's Day

  // 2025
  '2025-01-01', // New Year's Day
  '2025-04-18', // Good Friday
  '2025-04-21', // Easter Monday
  '2025-05-01', // Labour Day
  '2025-05-29', // Ascension Day
  '2025-06-09', // Whit Monday
  '2025-10-03', // Day of German Unity
  '2025-10-31', // Reformation Day
  '2025-12-25', // Christmas Day
  '2025-12-26', // St. Stephen's Day

  // 2026
  '2026-01-01', // New Year's Day
  '2026-04-03', // Good Friday
  '2026-04-06', // Easter Monday
  '2026-05-01', // Labour Day
  '2026-05-14', // Ascension Day
  '2026-05-25', // Whit Monday
  '2026-10-03', // Day of German Unity
  '2026-10-31', // Reformation Day
  '2026-12-25', // Christmas Day
  '2026-12-26', // St. Stephen's Day

  // 2027
  '2027-01-01', // New Year's Day
  '2027-03-26', // Good Friday
  '2027-03-29', // Easter Monday
  '2027-05-01', // Labour Day
  '2027-05-06', // Ascension Day
  '2027-05-17', // Whit Monday
  '2027-10-03', // Day of German Unity
  '2027-10-31', // Reformation Day
  '2027-12-25', // Christmas Day
  '2027-12-26', // St. Stephen's Day

  // 2028
  '2028-01-01', // New Year's Day
  '2028-04-14', // Good Friday
  '2028-04-17', // Easter Monday
  '2028-05-01', // Labour Day
  '2028-05-25', // Ascension Day
  '2028-06-05', // Whit Monday
  '2028-10-03', // Day of German Unity
  '2028-10-31', // Reformation Day
  '2028-12-25', // Christmas Day
  '2028-12-26', // St. Stephen's Day

  // 2029
  '2029-01-01', // New Year's Day
  '2029-03-30', // Good Friday
  '2029-04-02', // Easter Monday
  '2029-05-01', // Labour Day
  '2029-05-10', // Ascension Day
  '2029-05-21', // Whit Monday
  '2029-10-03', // Day of German Unity
  '2029-10-31', // Reformation Day
  '2029-12-25', // Christmas Day
  '2029-12-26', // St. Stephen's Day

  // 2030
  '2030-01-01', // New Year's Day
  '2030-04-19', // Good Friday
  '2030-04-22', // Easter Monday
  '2030-05-01', // Labour Day
  '2030-05-30', // Ascension Day
  '2030-06-10', // Whit Monday
  '2030-10-03', // Day of German Unity
  '2030-10-31', // Reformation Day
  '2030-12-25', // Christmas Day
  '2030-12-26', // St. Stephen's Day

  // 2031
  '2031-01-01', // New Year's Day
  '2031-04-11', // Good Friday
  '2031-04-14', // Easter Monday
  '2031-05-01', // Labour Day
  '2031-05-22', // Ascension Day
  '2031-06-02', // Whit Monday
  '2031-10-03', // Day of German Unity
  '2031-10-31', // Reformation Day
  '2031-12-25', // Christmas Day
  '2031-12-26', // St. Stephen's Day

  // 2032
  '2032-01-01', // New Year's Day
  '2032-03-26', // Good Friday
  '2032-03-29', // Easter Monday
  '2032-05-01', // Labour Day
  '2032-05-06', // Ascension Day
  '2032-05-17', // Whit Monday
  '2032-10-03', // Day of German Unity
  '2032-10-31', // Reformation Day
  '2032-12-25', // Christmas Day
  '2032-12-26', // St. Stephen's Day

  // 2033
  '2033-01-01', // New Year's Day
  '2033-04-15', // Good Friday
  '2033-04-18', // Easter Monday
  '2033-05-01', // Labour Day
  '2033-05-26', // Ascension Day
  '2033-06-06', // Whit Monday
  '2033-10-03', // Day of German Unity
  '2033-10-31', // Reformation Day
  '2033-12-25', // Christmas Day
  '2033-12-26', // St. Stephen's Day

  // 2034
  '2034-01-01', // New Year's Day
  '2034-04-07', // Good Friday
  '2034-04-10', // Easter Monday
  '2034-05-01', // Labour Day
  '2034-05-18', // Ascension Day
  '2034-05-29', // Whit Monday
  '2034-10-03', // Day of German Unity
  '2034-10-31', // Reformation Day
  '2034-12-25', // Christmas Day
  '2034-12-26', // St. Stephen's Day
]

/**
 * gets all the holidays for an specific year
 * @param year year of the holidays you want to receive.
 * @returns array of holiday dates of the year.
 */
export const getGermanyHolidaysByYear = (year: number): Date[] => {
  return publicHolidaysGermany.filter(date => date.startsWith(year.toString())).map(date => parseISO(date))
}
